import React from 'react';

import { FieldSet, Legend } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { PROPERTY_USAGE, PROPERTY_USAGE_RULES } from '../../../../constants';
import AdditionalRulesTemplate from './AdditionalRulesTemplate';
import RulesCheckbox from './RulesCheckbox';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const CHECKED_STATE = {};

for (const key of Object.keys(PROPERTY_USAGE.FIELD_NAME)) {
  CHECKED_STATE[PROPERTY_USAGE.FIELD_NAME[key]] = true;
}

const UNCHECKED_STATE = {};

for (const key of Object.keys(PROPERTY_USAGE.FIELD_NAME)) {
  UNCHECKED_STATE[PROPERTY_USAGE.FIELD_NAME[key]] = false;
}

export default function PropertyUsage_v1({ section, setSectionValues }: Props): JSX.Element {
  function togglePropertyUsageRules(): void {
    const isEnabled = section.getFieldValue(PROPERTY_USAGE.FIELD_NAME.IS_ENABLED);
    const setCheckboxes = isEnabled ? UNCHECKED_STATE : CHECKED_STATE;

    setSectionValues({
      ...setCheckboxes,
    });
  }

  function onBoxClick(event): void {
    const { value } = event.currentTarget.dataset;
    const checked = section.getFieldValue(value);

    setSectionValues({ [value]: !checked });
  }

  const switchedOn = section.getFieldValue(PROPERTY_USAGE.FIELD_NAME.IS_ENABLED);

  return (
    <AdditionalRulesTemplate
      title="Property Usage"
      caption="Choose the rules that will apply to your property and the grounds."
      switchTitle="Include property usage rules"
      switchedOn={switchedOn}
      toggleSwitch={togglePropertyUsageRules}
    >
      {switchedOn && (
        <FieldSet legend={<Legend>Choose which of these optional rules to include with your lease</Legend>}>
          {PROPERTY_USAGE_RULES.map((rule, index) => {
            const { FIELD_NAME } = rule;
            const checked = section.getFieldValue(FIELD_NAME);

            return (
              <RulesCheckbox
                controlId={`RulesCheckbox-${index}`}
                key={index}
                onBoxClick={onBoxClick}
                setSectionValues={setSectionValues}
                {...rule}
                checked={checked}
              />
            );
          })}
        </FieldSet>
      )}
    </AdditionalRulesTemplate>
  );
}

PropertyUsage_v1.description = 'DEPRECATED: Has checkbox for smoking';
